import React, { Component } from 'react';
import { getTextureUrl } from '../../../Common/TextureTools';
import { vanguardPossibilities } from './AdvertisementController';


class AddLodgingImage extends Component {
    render() {
        return <img
            src={getTextureUrl(72)}
            alt="ghost"
            style={{ width: '200px' }}
        />;
    }
}

export class VanguardGivesLodging extends Component {

    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;
    }

    componentDidMount() {
        const gameData = this.props.gameData;
        const gamePlayerData = this.props.gamePlayerData;
        const cardId = gamePlayerData.special_card;
        const availability = vanguardPossibilities(gameData, gamePlayerData, cardId);
        let lodgingIndexes = [];
        availability.forEach((isAvailable, lodgingIndex) => {
            if (isAvailable) lodgingIndexes.push(lodgingIndex);
        });

        window.dispatchEvent(
            new CustomEvent('highlight-lodging-event',
                {
                    detail: {
                        indexes: lodgingIndexes,
                        callback: this.onClick
                    }
                }));
    }

    componentWillUnmount() {
        window.dispatchEvent(new Event('clear-lodging-highlight-event'));
    }

    onClick = (lodgingGridIndex) => {
        this.api.clickVanguardLodging(lodgingGridIndex);
        window.dispatchEvent(new Event('clear-lodging-highlight-event'));
    }

    render() {
        return <></>
        // return <div className="justify-content-center d-flex align-items-center">
        //     <AddLodgingImage />
        // </div>
    }

}

